<div class="close-cross">
  <button mat-icon-button color="warn" class="negative-margin" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="displayPicturesContainer">
  <div class="picturesAndPaginatorContainer">
    <div style="display: flex; flex-direction: column; align-items: center; max-width: 100%">
      <div class="title">
        {{ title }}
      </div>
      <div style="display: flex; align-items: center; justify-content: center; max-width: 100%">
        <div class="arrowContainer" *ngIf="!isAllDisplay && pictures.length > 1">
          <mat-icon style="color: white" (click)="arrowClicked(false)">arrow_back</mat-icon>
        </div>
        <div class="pictureContainer" *ngIf="!isAllDisplay">
          <app-image-viewer [imageSrc]="pictures[currentIndex]" [viewerOptions]="viewerOptions"></app-image-viewer>
        </div>
        <div class="allPicturesContainer" *ngIf="isAllDisplay">
          <div *ngFor="let picture of pictures">
            <span style="margin: 5px"> <app-image-viewer [imageSrc]="picture" [viewerOptions]="viewerOptions"></app-image-viewer> </span>
          </div>
        </div>
        <div class="arrowContainer" *ngIf="!isAllDisplay && pictures.length > 1">
          <mat-icon style="color: white" (click)="arrowClicked(true)">arrow_forward</mat-icon>
        </div>
      </div>
      <div class="paginatorContainer" *ngIf="!isAllDisplay">
        <div *ngFor="let p of pictures; let i = index" class="thumbnailContainer" (click)="dotClicked(i)">
          <img [class]="currentIndex === i ? 'thumbnail blue' : 'thumbnail'" [src]="pictures[i]" />
        </div>
      </div>
    </div>
    <div *ngIf="isCompare" style="display: flex; flex-direction: column; align-items: center; max-width: 100%">
      <div class="title">
        {{ compare.title }}
      </div>
      <div style="display: flex; align-items: center; justify-content: center; max-width: 100%">
        <div class="arrowContainer" *ngIf="compare.pictures.length > 1">
          <mat-icon style="color: white" (click)="arrowClicked(false, true)">arrow_back</mat-icon>
        </div>
        <div class="pictureContainer">
          <app-image-viewer [imageSrc]="compare.pictures[compareCurrentIndex]" [viewerOptions]="viewerOptions"></app-image-viewer>
        </div>
        <div class="arrowContainer" *ngIf="compare.pictures.length > 1">
          <mat-icon style="color: white" (click)="arrowClicked(true, true)">arrow_forward</mat-icon>
        </div>
      </div>
      <div class="paginatorContainer">
        <div *ngFor="let p of compare.pictures; let i = index" class="thumbnailContainer" (click)="dotClicked(i, true)">
          <img [class]="compareCurrentIndex === i ? 'thumbnail blue' : 'thumbnail'" [src]="compare.pictures[i]" />
        </div>
      </div>
    </div>
  </div>
  <div class="changeDisplayButton" *ngIf="!isCompare && pictures.length > 1">
    <mat-icon (click)="isAllDisplay = !isAllDisplay">{{ isAllDisplay ? "photo" : "view_column" }}</mat-icon>
  </div>
  <div class="compareButton previous" *ngIf="previous && previous.pictures?.length && !isAllDisplay && !isCompare" (click)="compareClick()">
    <p>{{ ("observation.compareObs" | translate) + " " + previous.issued }}</p>
  </div>
  <div class="compareButton next" *ngIf="((next && next.pictures?.length) || isCompare) && !isAllDisplay" (click)="compareClick(true)">
    <p>
      {{
        isCompare
          ? ("dialog.patientAlreadyExists.differentOrganization.button.cancel" | translate)
          : ("observation.compareObs" | translate) + " " + next.issued
      }}
    </p>
  </div>
</div>
